<template>
  <gj-modal
      notFooterPadding
      size="1200_auto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增广告商品</template>
    <template #content>
      <el-form
          ref="form"
          :model="form">
        <app-base-info
            ref="base"
            :market-id="marketId"
            :form="form.baseInfoForm"
            :campaign="campaign"
            :group="group"
            group-select
        ></app-base-info>
        <app-product-picker
            ref="picker"
            :market-id="marketId"
            :group-id="form.baseInfoForm.groupId"
            group-required
            :form="form.productPickerForm"
            title="商品"
        ></app-product-picker>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../../../../minxins";
  import AppBaseInfo from "../common/base-info";
  import AppProductPicker from "../common/product-picker";
  import {AdGroupEnum} from "../../../../../common/enum";
  import {addSdAdProduct} from "../../../../../../../../api/ad";

  export default {
    name: "app-add-sd-ad-product",
    components: {AppProductPicker, AppBaseInfo},
    mixins: [modalMixIn],
    props: {
      marketId: {
        required: true
      },
      campaign: {
        required: false,
        default: null
      },
      group: {
        required: false,
        default: null
      }
    },
    data() {
      return {
        form: {
          baseInfoForm: {
            campaignTargetType: AdGroupEnum.SD.targetingType.PRODUCT_TARGETING,
            campaignId: null,
            groupId: null,
          },
          productPickerForm: {
            items: []
          }
        }
      }
    },
    methods: {
      confirm() {
        const formValid = !['base', 'picker'].some(e => !this.$refs[e].formValidate());
        if (formValid) {
          const params = {
            marketId: this.marketId,
            campaignId: this.form.baseInfoForm.campaignId,
            campaignName: this.form.baseInfoForm.campaignName,
            groupId: this.form.baseInfoForm.groupId,
            groupName: this.form.baseInfoForm.groupName,
            productParamList: this.form.productPickerForm.items.map(e => ({
              sku: e.msku,
              asin: e.asin
            }))
          };
          this.$emit('created');
          this.confirmLoading = true;
          addSdAdProduct(params)
            .then(() => {
              this.$gjDestroy();
              this.$emit('created');
            })
            .complete(() => this.confirmLoading = false);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../common/common";
</style>



